import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M12 8.875H8.25v3.75H12zm1.25 6.25v1.25H7v-1.25zm0-7.5v6.25H7v-6.25zm6.25 7.5v1.25h-5v-1.25zm0-2.5v1.25h-5v-1.25zm0-2.5v1.25h-5v-1.25zm0-2.5v1.25h-5v-1.25zM4.5 17V7.625H3.25V17a.63.63 0 0 0 .625.625A.63.63 0 0 0 4.5 17m16.25 0V6.375h-15V17c0 .215-.04.43-.107.625h14.482A.63.63 0 0 0 20.75 17M22 5.125V17c0 1.035-.84 1.875-1.875 1.875H3.875A1.875 1.875 0 0 1 2 17V6.375h2.5v-1.25z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }